import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  ContextMenu,
} from "./styles";
import { useHistory } from "react-router";

const Header = ({ t }: any) => {
  const history = useHistory();
  const [visible, setVisibility] = useState(false);
  const [isHovered, setisHovered] = useState(false);
  const setHover = (hover: boolean) => () => {
    setisHovered(hover);
  };
  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(!visible);
  };

  const goTo = (location: string) => () => {
    history.push(location);
  };
  const MenuItem = () => {
    const scrollTo = (id: string) => {
      history.push("/");
      try {
        setTimeout(() => {
          const element = document.getElementById(id) as HTMLDivElement;
          element.scrollIntoView({
            behavior: "smooth",
          });
        }, 300);
      } catch (e) {
        console.log("error no element detected", e);
      }
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall
          onMouseEnter={setHover(true)}
          onMouseLeave={setHover(false)}
          onClick={() => null}
        >
          <Span>{t("Show Case")}</Span>
          {isHovered && (
            <ContextMenu>
              <Span onClick={goTo("nani")}>{t("Nani")}</Span>
            </ContextMenu>
          )}
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("reachUs")}>
          <Span>{t("Reach Us")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => scrollTo("subscribe")}
        >
          <Span>
            <Button>{t("Subscribe")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <p
              style={{
                paddingTop: "35px",
                color: "#02efee",
                fontWeight: "bold",
              }}
            >
              Mega {`</>ers`}
            </p>
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={showDrawer}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} visible={visible} onClose={onClose}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={onClose}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
